export default "/fcbcac1db17390110677298f9d30eeed9c121039/d9f26165e744ef064b81249371ce3c44.svg";